import { IonIcon } from '@ionic/react';
import styled from 'styled-components';

export const StyledIonIcon = styled(IonIcon)`
  margin-top: 3px;
  margin-left: 4px;
  min-width: 16px;
`;
